import React from "react";
import { Link } from "react-router-dom";
import ListingCard from "@/components/ListingCard";

const isFree = (item) => !item.tier || item.tier === "free";

// Paid suppliers render first; free listings sit below a clearly-labelled divider.
// freeTotal is accepted for callers but no public count is displayed.
export default function ListingGrid({ items, className, freeTotal }) {
  const paid = items.filter((i) => !isFree(i));
  const free = items.filter(isFree);
  return (
    <>
      {paid.length > 0 && (
        <div className={className} data-testid="paid-listings-grid">
          {paid.map((item) => <ListingCard key={item.id} item={item} />)}
        </div>
      )}
      {free.length > 0 && (
        <>
          <div className={`flex items-center gap-4 ${paid.length ? "mt-10" : ""} mb-4`} data-testid="free-listings-divider">
            <div className="h-px flex-1 bg-[#C4CFC9]" />
            <div className="text-center">
              <div className="text-[10px] uppercase tracking-[0.2em] font-semibold text-[#7D8C85]" data-testid="free-listings-count">Free listings</div>
              <div className="text-[11px] text-[#9AA6A0] mt-0.5">
                Basic directory entries. Suppliers:{" "}
                <Link to="/pricing" className="underline hover:text-[#264839]" data-testid="free-divider-upgrade-link">upgrade to appear above</Link>
              </div>
            </div>
            <div className="h-px flex-1 bg-[#C4CFC9]" />
          </div>
          <div className={className} data-testid="free-listings-grid">
            {free.map((item) => <ListingCard key={item.id} item={item} />)}
          </div>
        </>
      )}
    </>
  );
}
